import React, { useEffect, useState } from "react";
import LeftSideNav from "../../../Components/LeftSideNav";
import Paper from "@mui/material/Paper";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import { Grid, Typography as Type, Typography } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Colors from "../../../theme/Colors";
import Fonts from "../../../Config/Fonts";
import { useLocation } from "react-router-dom";

const DetailItem = ({ label, value }) => (
  <Grid
    item
    xs={12}
    sm={18}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      width: "30vw",
    }}
  >
    <Typography variant="subtitle1" style={labelInfoStyle}>
      <div>{label}</div>
    </Typography>
    <Typography
      style={{
        width: "100%",
        justifyContent: "start",
        display: "flex",
      }}
    >
      <div style={inputTextStyle}>
        :
        <p
          style={{
            fontSize: 16,
            fontWeight: "400",
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            marginLeft: "5px",
          }}
        >
          {value}
        </p>
      </div>
    </Typography>
  </Grid>
);

const TransportDetails = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [transportDetail, setTransportDetail] = useState(null);

  const { transportData } = location?.state || {};

  useEffect(() => {
    //    if (transportId && prodMetalId?.product_metal_name) {
    if (transportData) {
      setBreadcrumbs([
        {
          key: "1",
          //  href: "/",
          text: "Masters",
        },
        { key: "2", href: "/transport", text: "Transport" },
        {
          key: "3",
          //   href: `/productPurity`,
          text: `View Transport Detail`,
        },
      ]);
      // setTransportDetail(transportData);
    }
  }, []);

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "20% 85%",
          height: "100vh",
          width: "100vw",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <LeftSideNav />

        <div
          style={{
            display: "grid",
            gridTemplateRows: "15% 80%",
            backgroundColor: Colors.bgColor,
          }}
        >
          <div style={{ width: "94%" }}>
            <TopNavBar leftSideText={"Transport Detail"} />
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>

          <TableContainer
            component={Paper}
            style={{
              width: "75vw",
              border: "1px solid #ccc",
              borderRadius: "15px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              marginTop: "10px",
              paddingLeft: "20px",
              marginLeft: "25px",
            }}
          >
            <h1 style={mainHeadingStyle}>Transport Detail</h1>

            <hr />
            <Grid container style={gridStyle}>
              <Grid container spacing={4}>
                <DetailItem
                  label="Name"
                  value={transportData?.transport_name || "N/A"}
                />
                <DetailItem
                  label="Head Office"
                  value={transportData?.transport_head_office_city || "N/A"}
                />
                <DetailItem
                  label="Service number"
                  value={transportData?.transport_service_number || "N/A"}
                />
                <DetailItem
                  label="Mobile Number"
                  value={transportData?.transport_mobile_number || "N/A"}
                />
                <DetailItem
                  label="Alternative Mobile Number"
                  value={
                    transportData?.transport_alternate_mobile_number || "N/A"
                  }
                />
              </Grid>
            </Grid>

            <h1 style={mainHeadingStyle}>Transport Available State & City</h1>
            <hr />
            <div style={tableDataStyle.tableContainer}>
              <table border={1} style={tableDataStyle.table}>
                <tr>
                  <th style={tableDataStyle.tableHeader}>State</th>
                  <th style={tableDataStyle.tableHeader}>GSTIN</th>
                  <th style={tableDataStyle.tableHeader}>Citys</th>
                </tr>
                <tr>
                  <td style={tableDataStyle.tableCell}>Gujarat</td>
                  <td style={tableDataStyle.tableCell}>12345</td>
                  <td style={tableDataStyle.tableCell}>
                    Ahm, mehsana, gandhinagar
                  </td>
                </tr>
              </table>
            </div>

            <h1 style={mainHeadingStyle}>Documents</h1>
            <hr />
            <Grid container style={gridStyle}>
              <Grid container spacing={4}>
                <DetailItem
                  label="Gujarat GST Certificate "
                  value={"Click here to view document"}
                />
                <DetailItem
                  label="Rajasthan GST Certificate "
                  value={"Click here to view document"}
                />
                <DetailItem
                  label="Visiting Card"
                  value={"Click here to view document"}
                />
                <DetailItem
                  label="Maharashtra GST Certificate"
                  value={"Click here to view document"}
                />
                <DetailItem
                  label="Service Number Certificate"
                  value={"Click here to view document"}
                />
              </Grid>
            </Grid>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "500",
  fontFamily: Fonts.Poppins, // Ensure this matches the loaded font
  color: Colors.headingBlackColor,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  display: "flex",
  alignItems: "center",
  width: "18%",
};

const labelTxtStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

const gridStyle = {
  marginTop: "35px",
  marginLeft: "35px",
};

const tableDataStyle = {
  tableContainer: {
    width: "90%",
    overflowX: "auto",
    marginTop: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ccc",
  },
  tableHeader: {
    backgroundColor: "#f5f5f5",
    color: "#333",
    fontWeight: "bold",
    padding: "12px 20px",
    textAlign: "left",
    borderBottom: "2px solid #ddd",
  },
  tableRow: {
    borderBottom: "1px solid #eee",
  },
  tableCell: {
    padding: "12px 20px",
    fontSize: "16px",
    color: "#555",
    textAlign: "left",
  },
};
export default TransportDetails;
